import { loadScripts } from 'load-resource-dynamically';

export default (target) => {
  let isLazyLoading = false

  const pollForReady = (element) => {
    const interval = setInterval(() => {
      if (isLazyLoading && document.readyState === 'complete') {
        clearInterval(interval)
        element.classList.remove('js-lazy-load')
        isLazyLoading = false
      }
    }, 200)
  }

  const io = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {
        isLazyLoading = true
        const element = entry.target
        if (element.nodeName.toLowerCase() === 'img') {
          const src = element.getAttribute('data-lazy')
          element.setAttribute('src', src)
        } else if (element.firstElementChild.nodeName.toLowerCase() === 'template') {
          const template = element.firstElementChild;
          $(element).html(template.innerHTML);

          if(template.dataset.js){
            element.classList.add('invisible');
            loadScripts([template.dataset.js]).then(function(){
              element.classList.remove('invisible');
            })
          }

        }
        pollForReady(element)
        observer.disconnect()
      }
    })
  })

  io.observe(target)
};
